import { types } from "./types";
import * as APIService from "../../../API/APIService";

const actions = (dispatch, state) => {
  const setResultStatus = (status) => {
    dispatch({
      type: types.SET_RESULT_STATUS,
      payload: {
        ...state.results,
        resultStatus: status,
      },
    });
  };

  const setInputForResults = (data) => {
    dispatch({
      type: types.SET_INPUT_FOR_RESULT,
      payload: {
        ...state.results,
        searchInput: data,
      },
    });
  };

  const getLatLon = (zipcode) => {
    APIService.getPosition(zipcode).then((results) => {
      setLatLong(results.data.LatLong[0]);
    })
  };

  const setLatLong = (latLong) => {
    dispatch({
      type: types.SET_LAT_LONG,
      payload: {
        ...state.results,
        latLong: latLong
      },
    });
  }

  const setExtendedSearchQualityScheme = (qualityScheme) => {
    dispatch({
      type: types.SET_QUALITYSCHEME_FILTERED,
      payload: {
        ...state.results,
        KwaliteitsregelingenFiltered: qualityScheme,
      },
    });
  };

  return {
    setResultStatus,
    setInputForResults,
    getLatLon,
    setLatLong,
    setExtendedSearchQualityScheme
  };
};

export { actions };

/*
const detailsLoaded = () => {
    dispatch({
      type: types.SET_DETAILS_LOADED,
      payload: {
        ...state.results,
        detailsLoaded: true,
      },
    });
  };

  const getAllResults = (path) => {
    if (sessionStorage.getItem("TNLedenzoekData")) {
      setAllData(JSON.parse(sessionStorage.getItem("TNLedenzoekData")).details.CompanyDetails);
    } else {
      APIService.getData(path).then((results) => {
        const details = results.data;
        sessionStorage.setItem(
          "TNLedenzoekData",
          JSON.stringify({
            details,
          })
        );
        setAllData(results.data.CompanyDetails);
      });
    }
  };

  const setAllData = (data) => {
    dispatch({
      type: types.GET_ALL_DATA_SUCCESS,
      payload: {
        ...state.results,
        Companies: data
      },
    });
  };

  const getSearchInput = () => {
    let searchInput;
    if (sessionStorage.getItem("TNLedenzoekSearchFor")) {
      searchInput = JSON.parse(sessionStorage.getItem("TNLedenzoekSearchFor"));
    } else {
      searchInput = {};
    }
    dispatch({
      type: types.GET_SEARCH_INPUT_SUCCES,
      payload: {
        ...state.results,
        searchInput
      },
    });
  }

  const getSpecialties = (path) => {
    let specialties;
    if (sessionStorage.getItem("TNLedenzoekFilterData")) {
      specialties = JSON.parse(sessionStorage.getItem("TNLedenzoekFilterData")).data.MappingKeywordAttribute;
    }
    dispatch({
      type: types.SET_SPECIALTIES,
      payload: {
        ...state.results,
        Specialties: specialties,
      },
    });
  }
  
  const getQualityScheme = (path) => {
    let qualityScheme;
    if (sessionStorage.getItem("TNLedenzoekFilterData")) {
      qualityScheme = JSON.parse(sessionStorage.getItem("TNLedenzoekFilterData")).data.Kwaliteitsregelingen;
    }
    dispatch({
      type: types.SET_QUALITY_SCHEME,
      payload: {
        ...state.results,
        QualityScheme: qualityScheme,
      },
    });
  }

  const setResults = (resultslist) => {
    dispatch({
      type: types.SET_RESULTS_LIST,
      payload: {
        ...state.results,
        resultslist
      },
    });
  }*/
